module.exports = __webpack_public_path__ + "static/img/version_confirm.f3c1145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/version_confirm.png
// module id = AcNg
// module chunks = 1